
import React from 'react';

interface InformationCircleIconProps {
  className?: string;
  title?: string; // Added title prop
}

export const InformationCircleIcon: React.FC<InformationCircleIconProps> = ({ className, title }) => (
  <span 
    className={`material-symbols-outlined ${className}`}
    aria-label={title ? title : 'Information'} // For screen readers
    {...(title && { title: title })} // Spread title for browser tooltip
  >
    info
  </span>
);